import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';
import { HttpRes } from '../../../models/common/http.model';
import { order_urls, registration_urls } from '../Constants/api-constants';

export interface GetParticipantOrdersOptions {
  event_id: number;
  category_id: number;
  page_num?: number;
  per_page?: number;
  created_by?: number;
  searchStr?: string;
  sort_name?: string;
  participant_type_id?: number | string;
  is_created_for?: boolean;
  is_active?: boolean | null;
  fetch_refund_settings?: boolean;
}

export interface GetMembershipOrderHistoryOptions {
  page?: number;
  page_size?: number;
  order_type_id?: number;
  include_details?: boolean;
  status?: string | null;
  planNames?: string[] | null;
  userRoles?: string[] | null;
  membershipStatuses?: string[] | null;
  seasons?: string[] | null;
  searchStr?: string | null;
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
  observe: 'response' as const,
};
@Injectable({
  providedIn: 'root',
})
export class OrderHistoryService {
  constructor(private readonly httpClient: HttpClient) {}

  selectedTournament: any;
  selectedTournamentName: any;
  private getSwitchUserRoleId(): string {
    if (!globalThis.window?.sessionStorage) {
      return '';
    }
    return (
      sessionStorage.getItem('switch_user_role_id') ||
      sessionStorage.getItem('switch_user_id') ||
      ''
    );
  }
  //ott/v1/get_participant_orders?x-sc=true&event_id=1&category_id=3&per_page=20&created_by=5'
  //http://34.93.36.43:7005/register/v1/get_user_registered_events?page_num=1&per_page=50

  //get events where user have send Entries
  get_user_registered_events(
    search_event: any = '',
    page_num = 1,
    per_page = 10,
    event_id: number = 0,
    event_type: string = '',
    include: string = ''
  ): Observable<HttpRes> {
    let params = new HttpParams();
    if (include) {
      params = params.set('include', include);
    }
    if (search_event != '' && search_event != undefined) {
      params = params.set('search', search_event);
    }
    if (page_num > 0) {
      params = params.set('page_num', page_num);
    }
    if (per_page > 0) {
      params = params.set('per_page', per_page);
    }
    if (event_type) {
      params = params.set('event_type', event_type);
    }

    return this.httpClient
      .get<HttpRes>(order_urls.get_user_registered_events, {
        params,
        ...httpOptions,
      })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.body.code,
            msg: response.body.msg,
            data: response.body.data,
            count: response.body.total,
          } as any;
        })
      );
  }
  //get orders of user based on event and category. remove by default event_id and category_id after proper registeration process
  get_participant_orders(
    event_id: number,
    category_id: number,
    page_num = 1,
    per_page = 10,
    created_by: number = 0,
    searchStr: string = '',
    sort_name: string = '',
    participant_type_id: any = 1,
    is_created_for?: boolean,
    is_active: any = null,
    fetch_refund_settings = false
  ): Observable<HttpRes> {
    let params = new HttpParams().set('x-sc', 'true');
    const switchUserRoleId = this.getSwitchUserRoleId();
    if (event_id > 0) {
      params = params.set('event_id', event_id);
    }
    if (category_id > 0) {
      params = params.set('category_id', category_id);
    }
    if (created_by > 0) {
      // params = params.set('created_by', 5)
    }
    if (page_num > 0) {
      params = params.set('page_num', page_num);
    }
    if (per_page > 0) {
      params = params.set('per_page', per_page);
    }
    if (searchStr != '') {
      params = params.set('search', searchStr);
    }
    if (sort_name != '') {
      params = params.set('sort_name', sort_name);
    }
    if (participant_type_id != '') {
      params = params.set('participant_type_id', participant_type_id);
    }

    if (typeof is_created_for === 'boolean') {
      params = params.set('is_created_for', is_created_for);
    }
    if (is_active !== null) {
      params = params.set('is_active', is_active);
    }
    if (switchUserRoleId) {
      params = params.set('switch_user_role_id', switchUserRoleId);
    }
    if (fetch_refund_settings) {
      params = params.set('fetch_refund_settings', 'true');
    }
    return this.httpClient
      .get<HttpRes>(order_urls.get_participant_orders, {
        params,
        ...httpOptions,
      })
      .pipe(
        shareReplay(),
        map((response: any) => {
          return {
            code: response.body.code,
            msg: response.body.msg,
            data: response.body.data,
          } as any;
        })
      );
  }

  get_membership_order_history(
    options: GetMembershipOrderHistoryOptions = {},
  ): Observable<HttpRes> {
    const {
      page = 1,
      page_size = 10,
      order_type_id = 1,
      include_details = true,
      status = null,
      planNames = null,
      userRoles = null,
      membershipStatuses = null,
      seasons = null,
      searchStr = null,
    } = options;

    let params = new HttpParams();
    if (page > 0) {
      params = params.set('page_num', page.toString());
    }
    if (page_size > 0) {
      params = params.set('per_page', page_size.toString());
    }
    if (status) {
      params = params.set('status', status);
    }
    if (order_type_id) {
      params = params.set('order_type_id', order_type_id.toString());
    }
    if (include_details) {
      params = params.set('include_details', include_details.toString());
    }
    if (planNames && planNames.length > 0) {
      params = params.set('plan_names', planNames.join(','));
    }
    if (userRoles && userRoles.length > 0) {
      params = params.set('user_roles', userRoles.join(','));
    }
    if (membershipStatuses && membershipStatuses.length > 0) {
      params = params.set('membership_statuses', membershipStatuses.join(','));
    }
    if (seasons && seasons.length > 0) {
      params = params.set('seasons', seasons.join(','));
    }
    if (searchStr) {
      params = params.set('search', searchStr);
    }

    return this.httpClient
      .get<HttpRes>(order_urls.get_membership_order_history, {
        params,
        ...httpOptions,
      })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.body.code,
            msg: response.body.msg,
            data: response.body.data,
          } as any;
        })
      );
  }

  get_user_registration_history(
    user_role_id: number,
    page_num = 1,
    per_page = 10
  ): Observable<HttpRes> {
    let params = new HttpParams();
    if (user_role_id) {
      params = params.set('user_role_id', user_role_id.toString());
    }
    if (page_num > 0) {
      params = params.set('page_num', page_num.toString());
    }
    if (per_page > 0) {
      params = params.set('per_page', per_page.toString());
    }

    return this.httpClient
      .get<HttpRes>(order_urls.get_user_registration_history, {
        params,
        ...httpOptions,
      })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.body.code,
            msg: response.body.msg,
            data: response.body.data,
            total: response.body.total,
          } as any;
        })
      );
  }

  get_partner_details(
    event_id: number,
    category_id: number,
    user_role_id: number
  ): Observable<HttpRes> {
    let params = new HttpParams();
    params = params.set('event_id', event_id);
    params = params.set('category_id', category_id);
    params = params.set('user_role_id', user_role_id);

    return this.httpClient
      .get<HttpRes>(registration_urls.get_partner_details, {
        params,
        ...httpOptions,
      })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.body.code,
            msg: response.body.msg,
            data: response.body.data,
          } as any;
        })
      );
  }

  withdraw_self_registered_player(payload: {
    participant_ids: number[];
    event_id: number;
    category_id: number;
    is_withdrawn: boolean;
  }): Observable<HttpRes> {
    return this.httpClient
      .post<HttpRes>(
        registration_urls.withdraw_own_registration,
        payload,
        httpOptions
      )
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.body.code,
            msg: response.body.msg,
            data: response.body.data,
          } as any;
        })
      );
  }

  cancel_partner_invitation(payload: {
    event_id: number;
    category_id: number;
    participant_type_id: number;
  }): Observable<HttpRes> {
    return this.httpClient
      .post<HttpRes>(
        registration_urls.cancel_partner_invitation,
        payload,
        httpOptions
      )
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.body.code,
            msg: response.body.msg,
            data: response.body.data,
          } as any;
        })
      );
  }

  create_partner_pair(payload: {
    event_id: number;
    category_id: number;
    participant_type_id: number;
    partner_user_role_id: number;
  }): Observable<HttpRes> {
    return this.httpClient
      .post<HttpRes>(
        registration_urls.create_partner_pair,
        payload,
        httpOptions
      )
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.body.code,
            msg: response.body.msg,
            data: response.body.data,
          } as any;
        })
      );
  }
}
